// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"priority-menu-item_uk-open__Wdrec","grecaptcha-badge":"priority-menu-item_grecaptcha-badge__hozIG","root":"priority-menu-item_root__wnOWp","title":"priority-menu-item_title__Xthw8","subtitle":"priority-menu-item_subtitle__mncwY","icon":"priority-menu-item_icon__GHKeU","text":"priority-menu-item_text__HTvFh","arrow":"priority-menu-item_arrow__FAfHO"};
    if(module.hot) {
      // 1793877059868
      var cssReload = require("!../../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  